export default "__VITE_ASSET__e96d72e3__"